export enum AccountLevel {
    user = 'user',
    customer = 'customer',
}
